import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import QueryParams from 'eflex/constants/bi-query-params';
import { torqueDataReports } from 'eflex/constants/bi-report-options';
import moment from 'moment-timezone';

export default class BiTorqueIndex extends Controller {
  @tracked drawerCollapsed = false;
  @tracked userIds = [];
  @tracked modelIds = [];
  @tracked stationIds = [];
  @tracked fasteners = [];
  @tracked tags = [];
  @tracked shiftNames = [];
  @tracked beginDate = moment().startOf('day').toISOString();
  @tracked endDate = moment().endOf('day').toISOString();
  @tracked refresher = false;
  queryParams = Object.keys(QueryParams);
  selectedReport = torqueDataReports.torqueSummary;

  get reportOptions() {
    return Object.values(torqueDataReports);
  }

  @action
  onSearch(params) {
    this.resetCriteria();
    Object.assign(this, params);
  }

  @action
  resetCriteria() {
    Object.assign(this, {
      userIds: [],
      modelIds: [],
      stationIds: [],
      fasteners: [],
      tags: [],
      shiftNames: [],
      beginDate: null,
      endDate: null,
    });
  }

  @action
  refresh() {
    this.refresher = true;
  }
}
